export default __webpack_public_path__ + "static/media/saree.d18e75aa.png";